import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';

import { ReportsMetricsActions } from '@core/reports-data';

@Injectable({ providedIn: 'root' })
export class ReportsRefreshService {
  private readonly store = inject(Store);
  public readonly onRevisit$ = new Subject<void>();

  public notifyRevisit(): void {
    this.store.dispatch(ReportsMetricsActions.fetchCollection());
    this.onRevisit$.next();
  }
}
